var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill"},[(_vm.patient_loading)?_c('div',{staticClass:"center"},[_c('loading')],1):_c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col m6 offset-m3"},[_c('patient-edit-form',{attrs:{"patient":_vm.patient.data}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }